import { render, staticRenderFns } from "./add-settle.vue?vue&type=template&id=67e9716d&scoped=true"
import script from "./add-settle.vue?vue&type=script&lang=ts"
export * from "./add-settle.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67e9716d",
  null
  
)

export default component.exports